import { createContext, useContext, useState } from "react";

const useApiPageProviderContext = () => {
  const [selectedLanguage, setSelectedLanguage] = useState("Shell");
  const [selectedTool, setSelectedTool] = useState("cURL");
  const [selectedEndpoint, setSelectedEndpoint] = useState("GetIpData");

  return {
    selectedLanguage,
    setSelectedLanguage,
    selectedEndpoint,
    setSelectedEndpoint,
    selectedTool,
    setSelectedTool,
  };
};

const ApiPageProviderContext = createContext(
  {} as ReturnType<typeof useApiPageProviderContext>
);

export const useApiPageContext = () => useContext(ApiPageProviderContext);

export const ApiPageContextProvider = ({ children }) => {
  return (
    <ApiPageProviderContext.Provider value={useApiPageProviderContext()}>
      {children}
    </ApiPageProviderContext.Provider>
  );
};
